import { BillPaymentError } from './payments.types'

export const createBillPaymentIdempotencyKey = (): string =>
  typeof globalThis.crypto?.randomUUID === 'function'
    ? globalThis.crypto.randomUUID()
    : `bill-payment-${Date.now()}-${Math.random().toString(36).slice(2)}`

export const shouldReconcileBillPaymentError = (
  error: BillPaymentError,
): boolean => {
  if (
    error.errorCode === 'IDEMPOTENCY_KEY_REUSED' ||
    error.errorCode === 'AUTHORIZATION_CODE_INVALID' ||
    error.errorCode === 'AUTHORIZATION_UNAVAILABLE' ||
    error.errorCode === 'PAYMENT_TERMS_NO_LONGER_VALID'
  ) {
    return false
  }
  return (
    error.status === undefined ||
    error.status >= 500 ||
    error.status === 409 ||
    error.status === 412 ||
    error.errorCode?.endsWith('_RESPONSE_INVALID') === true ||
    error.errorCode === 'PAYMENT_REVISION_STALE' ||
    error.errorCode === 'PAYMENT_STATE_CONFLICT' ||
    error.errorCode === 'PAYMENT_CONCURRENT_UPDATE' ||
    error.errorCode === 'AUTHORIZATION_CONFLICT'
  )
}
